import { FragmentType, gql, useFragment } from '@/__generated__';
import React from 'react';
import FontsDropdown from './fonts-dropdown';

const BrandFontsFragment = gql(`
  fragment BrandFontsFragment on Organization {
    fonts {
      runningText
      subtitle
      title
    }
  }
`);

interface FontsDropdownProps {
  fonts: FragmentType<typeof BrandFontsFragment>;
  onChange: (type: string, value: string | null) => void;
}

const Fonts: React.FC<FontsDropdownProps> = ({
  fonts,
  onChange,
}: FontsDropdownProps) => {
  const fontsFragment = useFragment(BrandFontsFragment, fonts);
  const handleFontChange = (type: string, fontId: string | null) => {
    onChange(type, fontId);
  };

  return (
    <>
      <p className='mb-2 mt-6 text-base font-medium'>Fonts</p>
      <div className='mb-4 flex items-center gap-4'>
        <p className='min-w-[100px] shrink-0 text-sm font-medium'>Title:</p>
        <FontsDropdown
          selectedFontId={fontsFragment?.fonts?.title}
          onChange={(fontId) => handleFontChange('title', fontId)}
        />
      </div>
      <div className='mb-4 flex items-center gap-4'>
        <p className='min-w-[100px] shrink-0 text-sm font-medium'>Subtitle:</p>
        <FontsDropdown
          selectedFontId={fontsFragment?.fonts?.subtitle}
          onChange={(fontId) => handleFontChange('subtitle', fontId)}
        />{' '}
      </div>
      <div className='flex items-center gap-4'>
        <p className='min-w-[100px] shrink-0 text-sm font-medium'>
          Running text:
        </p>
        <FontsDropdown
          selectedFontId={fontsFragment?.fonts?.runningText}
          onChange={(fontId) => handleFontChange('runningText', fontId)}
        />{' '}
      </div>
    </>
  );
};

export default Fonts;
